import { isOTCForwardSecurity } from '@talos/kyoko';
import type { Security } from '@talos/kyoko/src/types';

/**
 * Resolves the currency in which ForwardPrice is quoted (ProductDetails.QuoteAsset).
 * Uses {@link isOTCForwardSecurity} so instantiated forwards (with expiry on the security) resolve correctly.
 */
export function getForwardPriceCurrencyForSymbol(
  symbol: string | undefined,
  securitiesBySymbol: ReadonlyMap<string, Security> | undefined
): string | undefined {
  if (!symbol || !securitiesBySymbol) {
    return undefined;
  }
  const security = securitiesBySymbol.get(symbol);
  if (!isOTCForwardSecurity(security)) {
    return undefined;
  }
  return security.ProductDetails.QuoteAsset;
}
